import React, { useEffect, useState } from "react";

import moment from "moment";
import { useRecoilState } from "recoil";
import {
  Button,
  Checkbox,
  Input,
  InputPicker,
  Loader,
  Modal,
  Pagination,
  Placeholder,
  SelectPicker,
  Toggle,
} from "rsuite";
import Swal from "sweetalert2";
import { SiReadthedocs } from "react-icons/si";

import { createAPIEndpoint } from "../../API/authenticated.request";
import { exportAddAtom } from "../../Atoms/exportAdd.atom";
import { surveyStateAtom } from "../../Atoms/surveyState.atom";
import ExportAdd from "../../Components/Common/ExportAdd";
import Filter from "../../Components/Common/Filter";
import Grid from "../../Components/Grid/index";
import Responsive from "../../Components/Responsive";
import StatButton from "../../Components/Stat/StatButton";
import { Base_URL2 } from "../../Config/api.config";
import { surveyStatedata } from "../../data/data";
import { surveyTitles } from "../../data/filterData";
import { CustomerModel } from "../../Models/Customer";
import { surveyModel } from "../../Models/surveyModel";
import AddEdit from "./AddEdit";
import AddSurvey from "./AddSurvey";
import AdvancedSearch from "./AdvancedSearch";
import ComponentToPrint from "./Export/ComponentToPrint";
import { red } from "@mui/material/colors";
import zIndex from "@mui/material/styles/zIndex";
import { exportToExcel } from "./Export/Excel";

const Customer = () => {
  const [dataMootmars, setdataMootmars] = useState([]);
  const [dates, setdates] = useState([]);
  const [clients, setclients] = useState([]);
  const [state, setstate] = useRecoilState(exportAddAtom);
  const [model, setmodel] = useState(new CustomerModel());
  const [GuideNumbers, setGuideNumbers] = useState([]);
  const [clientNumbers, setClientNumbers] = useState([]);
  const [showCoupon, setShowCoupon] = useState(false);
  const [CouponData, setCouponData] = useState(null);

  //------------------------------------------------------------------------------------------------//
  const [SurveyModel, setSurveyModel] = useState(new surveyModel());
  const [Error, setError] = useState("");
  const [Seasons, setSeasons] = useState([]);
  const [hideNamesPDF, sethideNamesPDF] = useState(false);

  const [filterModel, setfilterModel] = useState({
    q: "",
    seasonId: 0,
    disponibilityId: null,
    clientId: 0,
    page: 1,
    take: 50,
    methodOfHearingAbout: 0,
    isFirstTime: null,
    generalReview: 0,
    branchReview: 0,
    guideReview: 0,
    airlineReview: 0,
    madinahHotelReview: 0,
    madinahServiceReview: 0,
    makkahHotelReview: 0,
    makkahServiceReview: 0,
    bestOf: 0,
    isRecommended: null,
    isCouponUsed: null,
  });

  const [surveyState, setsurveyState] = useRecoilState(surveyStateAtom);
  const [totalCount, settotalCount] = useState(0);
  const [Checked, setChecked] = useState(false);
  const [notDone, setnotDone] = useState(null);
  const [showNotDone, setshowNotDone] = useState(false);
  const [ShowDoc, setShowDoc] = useState(false);
  //////////////////////////////////////////////////////////////////////////
  //--------------------------set Customer type in table

  const CustomerType = (v) => {
    if (v == 1)
      return (
        <span
          style={{
            backgroundColor: "green",
            color: "white",
            textAlign: "center",
            padding: "2px 8px",
            borderRadius: 5,
            fontSize: 15,
          }}
        >
          Client
        </span>
      );
    else if (v == 2)
      return (
        <span
          style={{
            backgroundColor: "orange",
            color: "white",
            textAlign: "center",
            padding: "2px 8px",
            borderRadius: 5,
            fontSize: 15,
          }}
        >
          Guide
        </span>
      );
    else if (v == 3)
      return (
        <span
          style={{
            backgroundColor: "red",
            color: "white",
            textAlign: "center",
            padding: "2px 8px",
            borderRadius: 5,
            fontSize: 15,
          }}
        >
          Employé
        </span>
      );
  };
  //----------------------------------------------------
  const columns = [
    {
      value: "customer",
      render: (v) => {
        return (
          <p
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {
              <img
                src={Base_URL2 + "Uploads/CustomerPictures/" + v.picture}
                height={35}
                width={35}
                style={{
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              />
            }
          </p>
        );
      },
    },
    {
      name: "Nom",
      value: "customer",
      render: (v) => {
        return <p style={{ fontSize: 15, fontWeight: "bold" }}>{v.name}</p>;
      },
    },
    {
      name: "Type",
      value: "customer",
      render: (v) => {
        return <p style={{ fontSize: 15 }}>{CustomerType(v.customerType)}</p>;
      },
    },
    {
      name: "Date",
      value: "disponibility",
      render: (v) => {
        return (
          <p style={{ fontSize: 15 }}>
            {v ? moment(v.date).format("DD/MM/YYYY") : ""}
          </p>
        );
      },
    },
    {
      name: "Branche",
      value: "client",
      render: (v) => {
        return (
          <p
            //  style={branch_Color(v.name.substring(8))}
            style={{ fontSize: 15 }}
          >
            {v.name}
          </p>
        );
      },
    },

    {
      name: "Téléphone",
      value: "customer",
      render: (v) => {
        return (
          <p style={testNumbers(v)}>{v.phoneNumber ? v.phoneNumber : "--"}</p>
        );
      },
    },
    {
      name: "Survey",
      value: "surrveyState",
      render: (v) => {
        let x = surveyStatedata.find((el) => el.value == v);
        return (
          <div style={surveyStateColor(v)}>
            <span style={{ fontSize: 15 }}>{x ? x.label : ""}</span>
          </div>
        );
      },
    },
    {
      name: "Coupon Utilisé",
      value: "coupon",
      render: (v) => {
        return (
          <div>
            <span style={{ fontSize: 15, fontWeight: "bold" }}>{v}</span>
          </div>
        );
      },
    },
    {
      name: "Coupon",
      value: "customer",
      render: (v) => {
        return (
          <p>
            <Button
              color="yellow"
              appearance="ghost"
              style={{ fontSize: 12, padding: 5, fontWeight: "bold" }}
              onClick={() => {
                setShowCoupon(true);
                createAPIEndpoint("/Survey/GetByCustomerId")
                  .fetchById(v.id)
                  .then((resp) => {
                    setCouponData(() => ({
                      name: v.name,
                      coupon: resp.data.coupon,
                      isUsed: resp.data.isCouponUsed,
                    }));
                  })
                  .catch((err) => console.log(err));
              }}
              disabled={v.survey && v.survey.coupon ? false : true}
            >
              VOIR COUPON
            </Button>
          </p>
        );
      },
    },
  ];
  //---------------set Survey Color in Table
  const surveyStateColor = (v) => {
    if (v == 1) {
      return {
        backgroundColor: " #27ae60",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 2) {
      return {
        backgroundColor: " #7f8c8d",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 3) {
      return {
        backgroundColor: " black",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 4) {
      return {
        backgroundColor: " #e67e22",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 5) {
      return {
        backgroundColor: " #e74c3c",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 6) {
      return {
        backgroundColor: " #8e44ad",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    } else if (v == 7) {
      return {
        backgroundColor: " #22a6b3",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 5,
        padding: 2,
      };
    }
  };
  //----------------------------------------
  //-----------------check if it is Guide's Number or a Client Number
  const testNumbers = (v) => {
    let phoneNumbers = [];

    let style = {};
    if (v.phoneNumber != null) {
      if (v.phoneNumber.includes("/")) {
        phoneNumbers = v.phoneNumber.split("/");
      } else {
        phoneNumbers = [v.phoneNumber];
      }

      phoneNumbers.map((el) => {
        if (GuideNumbers.includes(el.trim())) {
          style = {
            color: "red",
            fontSize: 15,
            width: 100,
            overflowX: "auto",
          };
        } else if (clientNumbers.includes(el.trim())) {
          style = {
            color: "#27ae60",
            fontSize: 15,
            width: 100,
            overflowX: "auto",
          };
        } else {
          style = {
            fontSize: 15,
            fontWeight: "bold",
            width: 100,
            overflowX: "auto",
          };
        }
      });
    }
    return style;
  };
  //------------------------------------
  const getData = () => {
    createAPIEndpoint("/Order/UmrahCrm", filterModel)
      .fetch()
      .then((res) => {
        setdataMootmars(res.data.data);
        settotalCount(res.data.totalCount);
      })
      .then(() => {
        if (filterModel.disponibilityId) {
          createAPIEndpoint("/Order/UmrahCrm", {
            q: "",
            seasonId: 0,
            disponibilityId: filterModel.disponibilityId,
            clientId: 0,
            page: 1,
            take: 500,
          })
            .fetch()
            .then((res) => {
              setnotDone({
                label: "",
                value: res.data.data.filter(
                  (el) => el.customer.customerType == 1 && el.surrveyState == 0
                ).length,
              });
              setshowNotDone(true);
            });
        } else setshowNotDone(false);
      })
      .catch((err) => console.log(err));
  };
  const reset = () => {
    setError("");
    setmodel(new CustomerModel());
    setSurveyModel(new surveyModel());
    setChecked(false);
    setstate((prev) => {
      return { ...prev, open: false, loading: false };
    });
    setsurveyState((prev) => {
      return { ...prev, open: false, loading: false };
    });
    setCouponData(null);
    setShowCoupon(false);
  };
  const getSeasons = () => {
    createAPIEndpoint("Season", { page: 1, take: 1000 })
      .fetch()
      .then((res) => {
        setSeasons(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const Update = () => {
    setsurveyState((prev) => {
      return { ...prev, loading: true };
    });

    let modelCopy = { ...model };
    delete modelCopy.disponibility;
    delete modelCopy.client;
    delete modelCopy.price;
    delete modelCopy.packageUmrah;
    delete modelCopy.survey;
    delete modelCopy.surveyId;

    if (!SurveyModel.id) {
      if (modelCopy.surrveyState == 1 || modelCopy.surrveyState == 4) {
        modelCopy = {
          ...modelCopy,
          customer: {
            ...modelCopy.customer,
            survey: {
              ...SurveyModel,
              disponibilityId: model.disponibilityId,
              customerId: model.customer.id,
              clientId: model.client.id,
              dateVol: model.disponibility.date,
              guideName: model.guideName,
              hotelMakkah: model.price ? model.price.hotelMakkahName : "",
              hotelMadinah: model.price ? model.price.hotelMadinahName : "",
              createdBy: JSON.parse(localStorage.getItem("auth")).fullName,
              createdDate: new Date(),
              seasonId: 1,
            },
          },
        };
      }

      createAPIEndpoint("Order/Umrah")
        .update(modelCopy)
        .then(() => {
          if (Checked) {
            createAPIEndpoint("Message/SendCoupon")
              .fetchById(model.customer.id)
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .then((res) => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: ". تمّ التغير بنجاح ",
            showConfirmButton: false,
            timer: 1700,
          });

          getData();
          reset();
        })
        .catch((err) => {
          Swal.fire({
            position: "top-end",
            icon: "erroe",
            text: "Erreur",
            showConfirmButton: false,
          });
          console.log(err);
          setsurveyState((prev) => {
            return { ...prev, loading: false };
          });
        });
    } else {
      if (modelCopy.surrveyState == 1 || modelCopy.surrveyState == 4) {
        // delete modelCopy.customer.survey;
        createAPIEndpoint("Order/Umrah")
          .update(modelCopy)
          .then(() => {
            createAPIEndpoint("survey")
              .updateWithId(SurveyModel.id, {
                ...SurveyModel,
                disponibilityId: model.disponibilityId,
                updatedBy: JSON.parse(localStorage.getItem("auth")).fullName,
                updatedDate: new Date(),
                seasonId: 1,
              })
              .then(() => {
                if (Checked) {
                  createAPIEndpoint("Message/SendCoupon")
                    .fetchById(model.customer.id)
                    .then(() => getData())
                    .catch((err) => console.log(err));
                }
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .then(() => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: ". تمّ التغير بنجاح ",
              showConfirmButton: false,
              timer: 1700,
            });
            reset();
            getData();
          })
          .catch((err) => {
            Swal.fire({
              position: "top-end",
              icon: "erroe",
              text: "Erreur",
              showConfirmButton: false,
            });
            console.log(err);
            setsurveyState((prev) => {
              return { ...prev, loading: false };
            });
          });
      } else {
        modelCopy = {
          ...modelCopy,
          customer: { ...modelCopy.customer, survey: null, surveyId: null },
        };
        createAPIEndpoint("Order/Umrah")
          .update(modelCopy)
          .then((res) => {
            createAPIEndpoint("survey")
              .delete(SurveyModel.id)
              .then((res) => {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: ". تمّ التغير بنجاح ",
                  showConfirmButton: false,
                  timer: 1700,
                });
                reset();
                getData();
              })
              .catch((err) => console.log(err));
          })
          .catch((err) => {
            Swal.fire({
              position: "top-end",
              icon: "erroe",
              text: "Erreur",
              showConfirmButton: false,
            });
            console.log(err);
            setsurveyState((prev) => {
              return { ...prev, loading: false };
            });
          });
      }
    }
  };
  const getById = (id) => {
    createAPIEndpoint(`/Order/Umrah`)
      .fetchById(id)
      .then((res) => {
        setmodel(res.data);
        res.data.surrveyState == 1 || res.data.surrveyState == 4
          ? createAPIEndpoint("/Survey/GetByCustomerId")
              .fetchById(res.data.customerId)
              .then((resp) => {
                setSurveyModel(resp.data);
              })
              .catch((err) => console.log(err))
          : setSurveyModel(new surveyModel());
      })
      .catch((err) => console.log(err));
  };
  /////--------------Rooming----------------/////
  // const getRooms = () => {
  //   createAPIEndpoint("Rooming/getRooming")
  //     .fetchAll()
  //     .then((res) => console.log(res))
  //     .catch((err) => console.log(err));
  // };
  /////--------------Dates------------------/////

  const getDates = () => {
    createAPIEndpoint("PackageUmrah/getDates", { q: "" })
      .fetch()
      .then((res) => {
        let filteredDates = res.data.data.filter((date) =>
          filterModel.seasonId ? date.seasonId == filterModel.seasonId : date
        );
        setdates(
          filteredDates
            .reduce(
              (accumulator, el) => accumulator.concat(el.disponibilities),
              []
            )
            .map((el) => ({
              label: el.airline
                ? moment(el.date).format("DD/MM/YYYY") +
                  " -- " +
                  el.airline.fullName
                : "",
              value: el.id,
            }))
        );
      })
      .catch((err) => console.log(err));
  };
  ///----------------------------------------------
  ////------------------------Clients--------------------///
  const getClients = () => {
    createAPIEndpoint("Client/getAll")
      .fetchAll()
      .then((res) => {
        setclients(
          res.data.map((el) => ({
            label: el.name,
            value: el.id,
          }))
        );
        let numbers = [];
        res.data
          .filter((el) => el.phones != "" && el.phones != null)
          .map((el) => {
            if (el.phones.includes("/")) {
              el.phones = el.phones.split("/").map((phone) => phone.trim());
              numbers = [...numbers, ...el.phones];
            } else numbers = [...numbers, el.phones];
          });
        setClientNumbers(numbers);
        // console.log("numbers", numbers);
      })
      .catch((err) => console.log(err));
  };
  /////----------Get Guide Number----------/////
  const getGuidesNumbers = () => {
    createAPIEndpoint("Guide/getAll")
      .fetchAll()
      .then((res) => {
        // console.log(res);
        let numbers = [];
        res.data
          .filter((el) => el.phoneNumber != "" && el.phoneNumber != null)
          .map((el) => {
            if (el.phoneNumber.includes("/")) {
              el.phoneNumber = el.phoneNumber
                .split("/")
                .map((phone) => phone.trim());
              numbers = [...numbers, ...el.phoneNumber];
            } else numbers = [...numbers, el.phoneNumber.trim()];
          });
        setGuideNumbers(numbers);
      })

      .catch((err) => console.log(err));
  };
  //////-----------pdf------------------//////

  useEffect(() => {
    getData();
    getClients();
    getGuidesNumbers();
    getSeasons();
  }, []);
  useEffect(() => getDates(), [filterModel.seasonId]);

  return (
    <React.Fragment>
      <div style={{ width: "99%", margin: "auto", marginTop: "12px" }}>
        {/* <Button
          appearance="primary"
          onClick={() => {
            createAPIEndpoint("Survey/fixSurvey")
              .fetch()
              .then((res) => {
                console.log(res);
              });
          }}
        >
          FIX SURVEY
        </Button> */}
        <Filter
          search={getData}
          advanced
          advancedComponent={
            <AdvancedSearch
              filterModel={filterModel}
              _setfilterModel={setfilterModel}
              advancedData={surveyTitles}
            />
          }
        >
          <Responsive l={2.3} xl={2.3} className="p-10">
            <label>Recherche: </label>
            <Input
              value={filterModel.q}
              placeholder="Rechercher"
              onChange={(q) => {
                setfilterModel((prev) => {
                  return { ...prev, q, page: 1 };
                });
              }}
            />
          </Responsive>

          <Responsive l={2.3} xl={2.3} className="p-10">
            <label> Date de Vol: </label>
            <SelectPicker
              block
              placeholder="Rechercher"
              data={dates}
              onChange={(disponibilityId) => {
                setfilterModel((prev) => {
                  return { ...prev, disponibilityId, page: 1 };
                });
              }}
            />
          </Responsive>
          <Responsive l={2.3} xl={2.3} className="p-10">
            <label>Saison: </label>
            <InputPicker
              block
              data={[{ label: "Tout", value: 0 }].concat(
                Seasons.map((c) => {
                  return { label: c.designation, value: c.id };
                })
              )}
              value={filterModel.seasonId}
              placeholder="Rechercher"
              onChange={(seasonId) => {
                setfilterModel((prev) => {
                  return { ...prev, seasonId, page: 1 };
                });
              }}
            />
          </Responsive>
          <Responsive l={2.3} xl={2.3} className="p-10">
            <label> Agence: </label>
            <SelectPicker
              block
              placeholder="Rechercher"
              data={clients}
              onChange={(clientId) => {
                setfilterModel((prev) => {
                  return { ...prev, clientId, page: 1 };
                });
              }}
            />
          </Responsive>
        </Filter>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {showNotDone && (
          <Responsive m={2} l={2} xl={2} className="p-10">
            <StatButton data={notDone} backgroundColor="#e1b12c" />
          </Responsive>
        )}
      </div>
      <ExportAdd
        exportExcel={() => exportToExcel(dataMootmars)}
        pdfDownload
        pdfTitle={"Note"}
        pdfComponent={
          <ComponentToPrint
            data={dataMootmars
              .filter((el) => el.customer.survey)
              .filter((el) => el.customer.survey.note)}
            total={totalCount}
            hideNamesPDF={hideNamesPDF}
          />
        }
        ActionOnClose={reset}
        save={Update}
        saveSurvey={Update}
        size="full"
        noimportExcel
        AddComponent={
          <AddEdit
            error={Error}
            model={model}
            _setmodel={setmodel}
            getData={getData}
          />
        }
        AddsurveyComponent={
          <AddSurvey
            selectedMootamar={model}
            setselectedMootmar={setmodel}
            model={SurveyModel}
            _setmodel={setSurveyModel}
            Checked={Checked}
            setChecked={setChecked}
            clients={clients}
          />
        }
      />

      <div
        className="p-10"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          position: "relative",
        }}
      >
        <Toggle
          color="yellow"
          // disabled={showNamesPDF}
          onChange={() => sethideNamesPDF(!hideNamesPDF)}
        />
        <SiReadthedocs
          size={25}
          style={{ cursor: "pointer" }}
          onClick={() => setShowDoc(!ShowDoc)}
        />
        {ShowDoc && (
          <Responsive
            className="p-10"
            xl={3}
            l={3}
            m={4}
            style={{
              position: "absolute",
              right: 33,
              top: 35,
              backgroundColor: "white",
              zIndex: 999,
              borderRadius: 20,
              boxShadow:
                " 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Toggle color="yellow" />
              <span style={{ fontSize: 15, fontWeight: 500 }}>
                Afficher les Noms dans PDF
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div
                style={{
                  width: 18,
                  height: 18,
                  backgroundColor: "red",
                }}
              />
              <span style={{ fontSize: 15, fontWeight: 500 }}>
                Numero de Guide
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 5,
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 18,
                  height: 18,
                  backgroundColor: "#27ae60",
                }}
              />
              <span style={{ fontSize: 15, fontWeight: 500 }}>
                Numero Agence
              </span>
            </div>
          </Responsive>
        )}
      </div>

      <div style={{ width: "99%", margin: "auto" }}>
        <Grid
          actionKey="id"
          checkAction={(id) => {
            getById(id);
            setstate((prev) => {
              return { ...prev, open: true };
            });
          }}
          addServeyAction={(id) => {
            getById(id);
            setsurveyState((prev) => {
              return { ...prev, open: true };
            });
          }}
          columns={columns}
          noAdvancedActions={true}
          rows={dataMootmars}
        />

        <div style={{ padding: 20, background: "#fff" }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={["total", "-", "limit", "|", "pager", "skip"]}
            total={totalCount}
            limitOptions={[25, 50, 100, 300, 500, 1000]}
            limit={filterModel.take}
            activePage={filterModel.page}
            onChangePage={(page) => {
              setfilterModel((prev) => {
                return { ...prev, page };
              });
              createAPIEndpoint("/Order/Umrah", {
                ...filterModel,
                page,
              })
                .fetch()
                .then((res) => {
                  setdataMootmars(res.data.data);
                  settotalCount(res.data.totalCount);
                })
                .catch((err) => console.log(err));
            }}
            onChangeLimit={(take) => {
              setfilterModel((prev) => {
                return { ...prev, take, page: 1 };
              });
              createAPIEndpoint("/Order/Umrah", {
                ...filterModel,
                take,
                page: 1,
              })
                .fetch()
                .then((res) => {
                  setdataMootmars(res.data.data);
                  settotalCount(res.data.totalCount);
                })
                .catch((err) => console.log(err));
            }}
          />
        </div>
      </div>
      <div>
        <Modal size={"xs"} open={showCoupon} onClose={reset}>
          <Modal.Header>
            <Modal.Title>Etat Coupon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {CouponData ? (
              <div>
                <p style={{ padding: 5, fontWeight: "bold", fontSize: 17 }}>
                  <span>Nom: </span>
                  <span style={{ marginLeft: 10 }}>
                    {CouponData ? CouponData.name : "__"}
                  </span>
                </p>
                <p style={{ padding: 5, fontWeight: "bold", fontSize: 17 }}>
                  <span>Coupon:</span>
                  <span style={{ marginLeft: 10 }}>
                    {CouponData ? CouponData.coupon : "__"}
                  </span>
                </p>
                <p style={{ padding: 5, fontWeight: "bold", fontSize: 17 }}>
                  <span>Etat:</span>
                  <span
                    style={
                      CouponData.isUsed == 1
                        ? {
                            marginLeft: 10,
                            padding: 5,
                            background: "red",
                            color: "white",
                            borderRadius: 5,
                          }
                        : {
                            marginLeft: 10,
                            padding: 5,
                            background: "#2ecc71",
                            color: "white",
                            borderRadius: 5,
                          }
                    }
                  >
                    {CouponData && CouponData.isUsed == 1
                      ? "Utilisé"
                      : "Non Utilisé"}
                  </span>
                </p>
              </div>
            ) : (
              <p
              // style={{
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // }}
              >
                <Placeholder.Paragraph rows={2} />
                <Loader backdrop content="loading..." vertical />
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={reset} appearance="primary">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Customer;
